import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NewPage } from '../new/new';
import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-correo',
  templateUrl: 'correo.html',
})
export class CorreoPage {

  envi;
  reci;
  portada;
  user;
  lectura;
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: Http) {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.http.get('http://ebenlovequickpc.com/API/correo.php?cl=select-emi&usuario='+this.user.CODIGO_USER).subscribe((data)=>{
      this.envi = data.json();
    })
    this.http.get('http://ebenlovequickpc.com/API/correo.php?cl=select-rec&usuario='+this.user.CODIGO_USER).subscribe((data)=>{
      this.portada = data.json();
      this.reci = data.json();
    })
  }

  nuevo(){
    this.navCtrl.setRoot(NewPage,{estado: 'nuevo'});
  }

  responder(lect){
    this.navCtrl.setRoot(NewPage,{estado: 'respuesta', lectura: lect});
  }

  recibido(){
    this.portada = this.reci;
  }

  enviado(){
    this.portada = this.envi;
  }

  leer(mjs){
    this.lectura = mjs;
  }

}



// WEBPACK FOOTER //
// ./src/pages/correo/correo.ts